export type BannerOs = 'ios' | 'android' | undefined;

export enum NewsType {
  NEWS = 1,
  DISCLOSURE = 2,
  VOD = 3,
  HUGANGTUNG_NEWS = 11,
  HUGANGTUNG_REPORT = 14,
  STOCKPLUS_INSIGHT = 51,
  NOTICE = 61,
  CONTRACTED_NEWS = 1_001,
}

export enum AMPLITUDE_DISCLOSURE_TYPE {
  HAVE_DETAIL = 'Type 1',
  ONLY_CATEGORIZED = 'Type 2',
  ONLY_ALARM_BAR = 'Type 3',
  OTHER = 'Type 4',
}

export type DisclosureType = keyof typeof AMPLITUDE_DISCLOSURE_TYPE;
